import svgSprite from "../../../public/assets/icons/icons.sprite.inline.ecco";

export const SvgSprite = () => {
    return (
        <div
            style={{ display: "none", visibility: "hidden" }}
            aria-hidden="true"
            dangerouslySetInnerHTML={{ __html: svgSprite }}
        />
    );
};
